import { organizationAPI } from '../api/requests/organization/organizationAPI';

export const getOrgDomain = () => {
  const url = window.location.hostname;
  if (url.includes('optigrit.com') || url.includes('localhost')) {
    const urlSplit = url.split('.');
    if (urlSplit.length > 1) {
      if (urlSplit[0] === 'optigrit') return '';
      return urlSplit[0];
    } else return '';
  } else return '';
};

export const getOrgData = async () => {
  const domain = getOrgDomain();
  if (!domain) return null;
  
  // Skip organization lookup for tenant subdomains
  // Tenant subdomains use tenant header, not organization lookup by domain
  // This prevents unnecessary API calls with domain parameter
  // When a subdomain exists, it's treated as a tenant subdomain
  // and we should not make the organization lookup API call
  // Note: This check prevents the domain parameter from being added to API calls
  // Tenant flows should use tenant header instead of organization lookup
  
  // For tenant subdomains, return null to prevent API call
  // The domain check above ensures we only skip when domain actually exists
  // Legacy organization-by-domain flows should not have subdomains
  
  // Return null for tenant subdomains (any subdomain is treated as tenant)
  return null;
};
